import {
    SET_FORM_DATA_FROM_TABLE_ROLE_MASTER,
    SET_IS_EDITING_ROLE,
    SET_IS_CREATING_ROLE,
    SET_ALL_ROLES
} from "../actions/types";

const initialState = {
    formDataFromTableRoleMaster: {},
    isEditingRole: false,
    isCreatingRole: false,
    allRoles: []
};

const RoleMasterReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_FORM_DATA_FROM_TABLE_ROLE_MASTER:
            return { ...state, formDataFromTableRoleMaster: payload };

        case SET_IS_EDITING_ROLE:
            return { ...state, isEditingRole: payload };

        case SET_IS_CREATING_ROLE:
            return { ...state, isCreatingRole: payload };
        case SET_ALL_ROLES:
            return {...state, allRoles: payload}

        default:
            return state;
    }
};

export default RoleMasterReducer;